import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { fieldToTextField } from 'formik-material-ui';

const FormikAutocomplete = ({ textFieldProps, ...props }) => {  
  const { form: { setTouched, setFieldValue },label, handleEmptyRate } = props;
  const { error, helperText, ...field } = fieldToTextField(props);
  const { name } = field;

  return (
    <Autocomplete
      {...props}
      {...field}
      value={field.value}
      options={field.options}  
      getOptionLabel={option =>field.options.find((x) => x.id === option)?.label ?? option.label ?? ""}      
      onChange={ (_, value) => {
        setFieldValue(name, value===null?0:value.id)
        if (field?.name === "currencyId") {
          handleEmptyRate(value)
        }
      }}
      onBlur={ () => setTouched({ [name]: true }) }
      renderInput={ props => (
        <TextField {...props} {...textFieldProps} label={label} helperText={helperText} error={error} />
      )}
    />
  );
}

export default FormikAutocomplete;
